<p class="{{ sizeClass }}">
  <span [ngClass]="sizeClass !== 'footerTextXs' ? 'break-row' : 'hide'"></span>
  {{ copyRights }}
</p>
